import {store, router} from 'macarons'
import {Tracking} from './components'

export default {
  install (Vue, options) {
    Vue.$menu.registerDynamicMenuItems(() => {
      return store.dispatch('isGranted', {
        attribute: 'ROLE_EVALUATOR',
        subject: null
      }).then(allow => {
        return allow ? [{
          path: '/tracking',
          title: 'Tracking',
          icon: 'el-icon-fa-truck'
        }] : []
      }).catch(() => {
        return []
      })
    })
    router.addRoutes([
      {
        name: 'tracking',
        path: '/tracking',
        component: Tracking
      }
    ])
  }
}



// WEBPACK FOOTER //
// ./src/tracking/index.js